import React,{useState} from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import DateFnsUtils from '@date-io/date-fns';
import TextField from '@material-ui/core/TextField';
import styled from 'styled-components';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';

const DatePicker = ({ name, minDOBirth,maxDOBirth,value, callBackFun}) => {
    const TextFieldComponent = (props) => {
        return <TextField {...props} disabled={true} />
      }
    
  const [val, setVal] = useState(value);
  return (
    <DatePickerWrapper>
              <div className='custom-date-piker'>
                <div
                  className='file-input-wrapper'
                >
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      minDate={minDOBirth}
                      maxDate={maxDOBirth}                     
                      name={name}
                      margin="normal"
                      id="date-picker-dialog"
                      format="MM/dd/yyyy"
                      placeholder="MM/DD/YYYY"
                      value={val}
                      onChange={(date) => {
                        // let offsetTime = new Date().getTimezoneOffset()
                        // var newDate = new Date(date.getTime() + (offsetTime * 60 * 1000));
                        setVal(date)
                        return callBackFun(date);                          
                      }}
                      KeyboardButtonProps={{
                        'aria-label': 'change date',
                      }}
                      TextFieldComponent={TextFieldComponent}
                    />

                  </MuiPickersUtilsProvider>

                </div>
              </div>

    </DatePickerWrapper>
  );
};

export default DatePicker;
const DatePickerWrapper = styled.div`
  .MuiFormControl-marginNormal {
    margin: 0;
  }
`
